import React from 'react';
import { Grid, GridColumn, Icon, Separator, Text, TIconSize } from 'telia-front-react';

interface IAdditionalInformationItemProps {
  children: React.ReactNode;
  icon?: string;
  iconSize?: TIconSize;
}

const AdditionalInformationItem = (props: IAdditionalInformationItemProps): JSX.Element => {
  const { children, icon, iconSize } = props;

  return (
    <Grid noWrap={true}>
      <GridColumn width={['min']}>
        <Icon modifiers={icon} size={iconSize} />
      </GridColumn>
      <GridColumn width={['max']}>
        <Text>
          {children}
          <Separator color="invisible" spacing="xsmall" />
        </Text>
      </GridColumn>
    </Grid>
  );
};

export default AdditionalInformationItem;
